import {
  Toolbar,
  Typography,
} from "@mui/material";
import StyledAppBar from "./StyledAppBar";

export default function PublicBar() {

  const appName = process.env.REACT_APP_NAME || "My App";

  return (
    <>
      <StyledAppBar position="static">
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1, marginBottom: "0rem" }}>
            {appName}
          </Typography>
        </Toolbar>
      </StyledAppBar>
    </>
  );
}
